import { useCallback, useMemo } from 'react';
import { useAppAuthorizedUser } from '../../redux/hooks';

export const useUserRolesRef = () => {
  const { authRoles } = useAppAuthorizedUser();

  const hasRole = useCallback(
    (role: string) =>
      authRoles.includes(role) || authRoles.includes('enterpriseAdmin'),
    [authRoles]
  );

  const rolesEnabled = useMemo(
    () => ({
      isEnterpriseAdmin: hasRole('enterpriseAdmin'),
      isUserAdmin: hasRole('userAdmin'),
      isTemplateConfigurator: hasRole('templateConfigurator'),
      isPatientRounder: hasRole('patientRounder'),
      isEmployeeRounder: hasRole('employeeRounder'),
      isValidationRounder: hasRole('validationRounder'),
      isAidetValidationRounder: hasRole('aidetValidationRounder'),
      isBssrValidationRounder: hasRole('bssrValidationRounder'),
      isNonSupportRounder:
        hasRole('patientRounder') || hasRole('employeeRounder'),
      isAllNonSupportRounder:
        hasRole('patientRounder') && hasRole('employeeRounder'),
      isCNEdRounder: hasRole('cnedRounder'),
      isCSCRounder: hasRole('csrnRounder'),
      isSupportRounder: hasRole('cnedRounder') || hasRole('csrnRounder'),
      isAllSupportRounder: hasRole('cnedRounder') && hasRole('csrnRounder'),
      isAllValidationRounder:
        hasRole('validationRounder') &&
        hasRole('aidetValidationRounder') &&
        hasRole('bssrValidationRounder'),
      isAnyValidationRounder:
        hasRole('validationRounder') ||
        hasRole('aidetValidationRounder') ||
        hasRole('bssrValidationRounder'),
      hasMultipleValidationRoles:
        [
          hasRole('validationRounder'),
          hasRole('aidetValidationRounder'),
          hasRole('bssrValidationRounder')
        ].filter(Boolean).length > 1,
      isMultipleRounders: authRoles.length > 1,
      numOfRoles: authRoles.length
    }),
    [authRoles, hasRole]
  );

  return rolesEnabled;
};
